import { render, staticRenderFns } from "./ProfessionalInfo_1.vue?vue&type=template&id=3ed069f2"
import script from "./ProfessionalInfo_1.vue?vue&type=script&lang=js"
export * from "./ProfessionalInfo_1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports